export default __webpack_public_path__ + "ff49a416cf4878ef3d9c0e42f101d99f.svg";